export default function Star({ className }) {
    return (
        <svg className={className} id="uuid-3bc2b44a-3f23-412d-a898-3bfdd0e5c98b" data-name="Schrift" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 489.14 439.28">
          <path d="m380.71,185.46h-102.1l-34.03-102.68-34.03,102.68h-102.1l78.36,68.35-30.6,102.67,88.37-61.49,88.37,61.49-30.6-102.68,78.36-68.35Z" style="fill: #e20432; stroke-width: 0px;"/>
        </svg>
    );
  }
  